export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10779.6ec1149b.jpg";